import {Component, inject} from '@angular/core';
import {MatFormField} from '@angular/material/form-field';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {MatButton} from '@angular/material/button';
import {MatInput} from '@angular/material/input';
import {NgIf} from '@angular/common';
import {LoginService} from '@services/login/login.service';
import {UserService} from '@services/user/user.service';
import {Router} from '@angular/router';
import {AccountTypeEnum} from '@interfaces/doctors';
import {NzModalModule, NzModalService} from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-login',
  imports: [
    MatFormField,
    MatButton,
    MatInput,
    ReactiveFormsModule,
    NgIf,
    NzModalModule
  ],
  templateUrl: './login.component.html',
  standalone: true,
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  form: FormGroup = new FormGroup({
    email: new FormControl(''),
    password: new FormControl(''),
  });

  private loginService = inject(LoginService);
  private userService = inject(UserService);
  private router = inject(Router);


  constructor(private modal: NzModalService) {}

  submit() {
    if (this.form.valid) {
      this.submitEM(this.form.value);
    }
  }

  error?: string | null;

  submitEM(form: any) {
    this.loginService.loginUser(form.email, form.password)
      .subscribe(
        {
          next: (res: any) => {
            if(res.role !== AccountTypeEnum.ADMIN && res.role !== AccountTypeEnum.ANNOTATOR) {
              this.showError();
              return;
            }
            console.log('LoginComponent: login success', res);
            this.router.navigate(['/']);
          },
          error: (err: any) => {
            console.log('LoginComponent: login error', err);
            this.error = err.error.message;
          }
        }
      );
  }

  showError(): void {
    this.modal.error({
      nzTitle: 'You are not authorized to access this page',
      nzContent: 'Please contact your administrator for more information.',
      nzOkText: 'OK',
    });
  }

}
